import { getProductSalesReportService } from "@/helpers/service/api/report";
import { json2csv_fn, salesStatus, taxRatesMap, toThousands } from "@/utils/common";
import locale from "@/helpers/locale";
import moment from "moment";
import { getExportName_fn, getOperatorText } from '@/utils/common'
export function exportCSV_fn(requestParma, goodsList, startDate, endDate, weekLocaleArray) {
  getProductSalesReportService(requestParma).then(res => {
    if (res.data.records.length > 0) {
      let csvData = [];
      const fields = [
        {
          label: locale("trans.koisk.transid"),
          value: "searchId",
        },
        {
          label: locale("global.date"),
          value: "transactionCreateTime",
        },
        {
          label: locale("inventoryLog.name"),
          value: "productName",
        },
        {
          label: locale("global.department"),
          value: "group",
        },
        {
          label: locale("trans.koisk.salesgroup"),
          value: "productType",
        },
        {
          label: locale("global.unitPrice"),
          value: "unitPrice",
        },
        {
          label: locale("global.quantity"),
          value: "qty",
        },
        {
          label: locale("global.amount"),
          value: "total",
        },
        {
          label: locale("global.coupon"),
          value: "couponTypeName",
        },
        {
          label: locale("global.taxRate"),
          value: "taxRateText",
        },
        {
          label: locale("trans.koisk.paymentName"),
          value: "paymentName",
        },
        {
          label: locale("inventoryLog.changePeople"),
          value: "operator",
        },
        {
          label: locale("global.status"),
          value: "statusText",
        }
      ];
      res.data.records.forEach(item => {
        csvData.push({
          searchId: item.searchId + "\t",
          transactionCreateTime: moment(item.transactionCreateTime).format("YYYY-MM-DD HH:mm") + "\t",
          productName: item.productName,
          group: item.group,
          productType: item.productType,
          unitPrice: item.unitPrice,
          qty: toThousands(item.qty) + "\t",
          total: item.total,
          couponTypeName: item.couponTypeName,
          taxRateText: taxRatesMap[item.taxRate.toString()],
          paymentName: item.paymentName,
          operator: getOperatorText(item),
          statusText: salesStatus[item.itemStatus],
        });
      });
      json2csv_fn(csvData, fields,
      // moment().format("YYYYMMDDHHmm") + "_" + locale("sideMenu.reports.shopTransaction")
      getExportName_fn(
        locale("sideMenu.reports.shopTransaction"),
        '',
        '',
        '',
        `${moment(startDate).format('YYYY-MM-DD')} （${weekLocaleArray[moment(startDate).day()]}）~ ${moment(endDate).format('YYYY-MM-DD')} （${weekLocaleArray[moment(endDate).day()]}）`,
        res.data.cinemaName,
        moment().format('YYYYMMDDHHmm')
      )
      );
    }
  });
}